export default "__VITE_PUBLIC_ASSET__cd1e2d8c__"